import * as React from "react";
import ButtonData from "./ModuleData";

import ContentEditable from "../../components/ContentEditable";

import { isRgbString, rgbStringToHex } from '../../components/color-picker/utils';

import { WebViewProps } from "../interfaces";

export interface ButtonWebViewProps extends WebViewProps<ButtonData>, React.Props<ButtonWebView> {
}

export default class ButtonWebView extends React.Component<ButtonWebViewProps, {}> {

    ButtonText: HTMLElement;

    private anchor: HTMLAnchorElement;

    componentDidMount() {
        this.props.onDataChange(Object.assign({}, this.props.payload, {
            defaultBackgroundColor: this.getDefaultHexColor('backgroundColor'),
            defaultTextColor: this.getDefaultHexColor('color')
        }));

        this.updateAnchorStyle();
    }

    componentDidUpdate(prevProps: ButtonWebViewProps) {
        if (
            prevProps.payload.backgroundColor !== this.props.payload.backgroundColor ||
            prevProps.payload.textColor !== this.props.payload.textColor
        ) {
            this.updateAnchorStyle();
        }
    }

    render() {
        // TODO use ContentEditable only if needed, based on a prop
        const style = {
            textAlign: this.props.payload.supports.buttonAlign ? this.props.payload.align : null,
            width: '100%'
        };

        return (
            <div style={style}>
                <ContentEditable
                    onChange={this.onTextChange}
                    value={this.props.payload.text}
                    maxLength={1000}
                >
                    <a
                        ref={(a) => this.anchor = a}
                        className={this.props.payload.style}
                        href={this.props.payload.link}
                        target={this.props.payload.linkTarget}
                    />
                </ContentEditable>
            </div>
        );
    }

    private getDefaultHexColor = (propertyName: 'backgroundColor' | 'color') => {
        const rgbString =
            propertyName === 'backgroundColor'
                ? window.getComputedStyle(this.anchor).backgroundColor
                : window.getComputedStyle(this.anchor).color
        ;
        const hexColor =
            isRgbString(rgbString)
                ? rgbStringToHex(rgbString)
                : 'FFFFFF' // For RGBA values, we default to white.
        ;

        return hexColor;
    }

    // We need to do it like this,
    // as React doesn't support inline styles with "important".
    // We need to use "important", as some themes do it also, unfortunately.
    private updateAnchorStyle = () => {
        if (this.props.payload.backgroundColor) {
            const backgroundColor = `#${this.props.payload.backgroundColor}`;

            this.anchor.style.setProperty('background-color', backgroundColor, 'important');
            this.anchor.style.setProperty('border-color', backgroundColor, 'important');
        } else {
            this.anchor.style.removeProperty('background-color');
            this.anchor.style.removeProperty('border-color');
        }

        if (this.props.payload.textColor) {
            const textColor = `#${this.props.payload.textColor}`;

            this.anchor.style.setProperty('color', textColor, 'important');
        } else {
            this.anchor.style.removeProperty('color');
        }
    };

    private onTextChange = (textContent: string) =>  {
        this.props.onDataChange(
           Object.assign({}, this.props.payload, {
               text: textContent
           })
        );
    };
};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/button/WebView.tsx
 **/